import { Component, Input, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Router } from '@angular/router';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import firebase from 'firebase/app';
import { BaseComponent } from 'src/app/shared/base/base.component';
import { FirebaseAuthComponent } from 'src/app/shared/firebase-auth/firebase-auth.component';
import { MessagesService } from 'src/app/shared/services/messages/message.service';
import { TutorService } from 'src/app/shared/services/tutor/tutor.service';
import { Student } from '../tiposFormulario/student';



@Component({
  selector: 'app-academic',
  templateUrl: './academic.component.html'
})
export class AcademicComponent extends BaseComponent  implements OnInit {

  @Input()
  public user;
  public userAuth;

  public tempIndex = 0;
  public student = new Student();
  public currentMonth;
  public cargando = false;

  public readonly chevronLeft = faChevronLeft;
  public readonly chevronRight = faChevronRight;

  @Input()
  public projects: any[];

  public months = {
    0: 'Enero', 1: 'Febrero', 2: 'Marzo', 3: 'Abril', 4: 'Mayo', 5: 'Junio', 6: 'Julio', 7: 'Agosto',
    8: 'Septiembre', 9: 'Octubre', 10: 'Noviembre', 11: 'Diciembre'
  };

  constructor(public firebaseAuth: FirebaseAuthComponent,
              private router: Router,
              private firestore: AngularFirestore,
              private messageService: MessagesService,
              private tutorService: TutorService) {

      super();
  }

  ngOnInit(): void {
    this.courseCurrent = this.students[this.studentCurrent].courseInfoArr[0];
    console.log('el user en evaluation es ', this.user);
    console.log('los estudiantes son ', this.students);
  }

  showButtonCompleteInscription(idCourse: string): boolean {
    return this.students[this.studentCurrent].status === 'test';
    // return this.students[this.studentCurrent].statusCourses.filter(x => (x.idStatus === '/courses/' + idCourse
    // || x.idStatus === 'courses/' + idCourse) && x.courseStatus === 'test').length > 0;
  }

  completarInscription(idCurso: string): void {
    this.cargando = true;
    this.students[this.studentCurrent]?.statusCourses
      .map(x => {
        if (x.idStatus === `/courses/${idCurso}` || x.idStatus === `courses/${idCurso}`) {
          x.courseStatus = 'test';
        }
        return x;
      });

    this.firestore.collection('users').doc(this.user.id)
      .ref.update({
        registrationDate: new Date(),
      })
      .then(x => {
        this.firestore.collection('users').doc(this.students[this.studentCurrent].id)
          .ref.update({
            statusCourses: this.students[this.studentCurrent].statusCourses,
            status: 'registrado'
          })
          .then(y => {
            this.cargando = false;
            this.router.navigate([`/contrato`]);
            setTimeout(() => {
              this.tutorService.changeIdTutor(this.user.id);
            }, 500);
          })
          .catch(err => {
            this.cargando = false;
            this.messageService.openAlertDialog(err, 'Hubo un error modificando el estudiante');
          });
      })
      .catch(err => {
        this.cargando = false;
        this.messageService.openAlertDialog(err, 'Hubo un error modificando el tutor');
      });

    console.log('el esudiante modificado es ', this.students[this.studentCurrent]);
    console.log('el tutor  es ', this.user);
  }

  liberarPlaza(): void {
    this.firestore.collection('users').doc(this.students[this.studentCurrent].id)
      .ref.update({
        emailSend: firebase.firestore.FieldValue.delete(),
        codePromocionalId: firebase.firestore.FieldValue.delete()
      })
      .then(y => {
        this.cargando = false;
        this.router.navigate([`/infoacademica`]);
        setTimeout(() => {
          this.tutorService.changeIdTutor(this.user.id);
        }, 500);
      })
      .catch(err => {
        this.cargando = false;
        this.messageService.openAlertDialog(err, 'Hubo un error modificando el estudiante');
      });
  }

  checkIfIsTest(): boolean {
    const response: any[] = this.students[this.studentCurrent]?.statusCourses
    .filter(status => status.idCourse === this.courseCurrent.id && status.courseStatus === 'test');
    return response.length > 0;
  }
}
